import { render, staticRenderFns } from "./nvLeadForm.vue?vue&type=template&id=12e647fa&"
import script from "./nvLeadForm.vue?vue&type=script&lang=js&"
export * from "./nvLeadForm.vue?vue&type=script&lang=js&"
import style0 from "./nvLeadForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports